"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19,21.35a5,5,0,1,1,5-5A5,5,0,0,1,19,21.35Z",
    fill: "#024965"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.76,13.58a.57.57,0,0,0-.8.14l-2.85,4L17,16.59a.59.59,0,0,0-.81,0,.57.57,0,0,0,0,.81L17.79,19a.57.57,0,0,0,.87-.08l3.24-4.59A.57.57,0,0,0,21.76,13.58Z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.43,10.4a7.24,7.24,0,0,0-4-5,3.1,3.1,0,0,0-6.17,0A7.25,7.25,0,0,0,2.08,12v4.69A1.59,1.59,0,0,1,.5,18.27a.5.5,0,1,0,0,1H6.82a2.58,2.58,0,0,0,5.06,0h1.34a6.46,6.46,0,0,1,3.21-8.87Z",
    fill: "#024965"
  }));
};

exports["default"] = _default;